import type { MetaFunction } from '@remix-run/node';
import { json, Link, useLoaderData } from '@remix-run/react';
import { Container } from '~/components/Container';

import { Layout } from '~/components/Layout';
import { PageHeading } from '~/components/PageHeading';
import { PageSubHeading } from '~/components/PageSubHeading';
import { Badge } from '~/components/ui/badge';
import { db } from '~/lib/db.server';
import { getCacheControlHeader } from '~/lib/http.server';
import { appendMetaTitleSuffix } from '~/lib/utils/meta';

export const loader = async () => {
  const brands = await db.brand.findMany({
    orderBy: {
      id: 'asc',
    },
  });

  let firstLetters = brands.map((brand) => brand.name.charAt(0).toLocaleUpperCase());
  firstLetters = Array.from(new Set(firstLetters));

  return json(
    {
      brands,
      firstLetters
    },
    {
      headers: {
        ...getCacheControlHeader()
      }
    }
  );
};

export const meta: MetaFunction = () => {
  return [
    { title: appendMetaTitleSuffix('エフェクタープランド') },
    { name: 'description', content: 'StompBase（ストンプベース）に掲載されているエフェクターブランドの一覧です。' },
  ];
};

const BrandsRoute = () =>  {
  const { brands, firstLetters } = useLoaderData<typeof loader>();

  return (
    <Layout>
      <Container>
        <PageHeading>
          エフェクターブランド
        </PageHeading>

        <div className="flex flex-wrap flex-row gap-3 md:gap-2 items-center mb-10">
          {firstLetters.map((firstLetter) => (
            <Link key={firstLetter} to={`#${firstLetter}`}>
              <Badge variant="outline" className={'text-slate-400 font-normal text-md　py-1.5 px-3 min-w-10 justify-center hover:bg-slate-100 hover:text-gray-700'}>
                {firstLetter}
              </Badge>
            </Link>
          ))}
        </div>

        <div>
          {firstLetters.map((firstLetter) => (
            <div key={firstLetter} id={firstLetter} className="mb-14">
              <div className='mb-2'>
                <PageSubHeading color='gray'>
                  {firstLetter}
                </PageSubHeading>
              </div>

              <ul className={'grid grid-cols-1 md:grid-cols-4 gap-4'}>
                {brands
                  .filter((brand) => brand.name.charAt(0).toLocaleUpperCase() === firstLetter)
                  .map((brand) => (
                    <li key={brand.id}>
                      <Link to={`/brands/${brand.id}`} className={'text-gray-700 font-bold hover:underline hover:text-indigo-400 flex items-center'}>
                        {brand.name}
                        <span className='ml-[6px] mt-[1px] text-slate-400 text-xs font-normal'>
                          (<span className='mx-[2px]'>{brand.pedalCount}</span>)
                        </span>
                      </Link>
                    </li>
                  ))}
              </ul>
            </div>
          ))}
        </div>
      </Container>
    </Layout>
  );
}

export default BrandsRoute;